import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

export const BusinessOfferingsFeatures: LandingPageFeature[] = [
  {
    id: 'offerings-oura-app',
    title: 'business_offerings_title_1',
    description: 'business_offerings_description_1',
    image: {
      format: 'png',
      localizedAlt: 'business_image_oura_app_alt',
      localizedSrc: 'business_image_oura_app',
    },
  },
  {
    id: 'offerings-teams',
    title: 'business_offerings_title_2',
    description: 'business_offerings_description_2',
    image: {
      format: 'png',
      localizedAlt: 'business_image_meeting_alt',
      src: 'blue-sky/oura-for-business/business-meeting.png',
    },
  },
  {
    id: 'offerings-api',
    title: 'business_offerings_title_3',
    description: 'business_offerings_description_3',
    image: {
      format: 'png',
      localizedAlt: 'business_image_ipad_alt',
      src: 'blue-sky/oura-for-business/business-ipad.png',
    },
  },
];
